import { PxdGridEditService } from '@app/shared/kendoui/grid/services/pxd-grid-edit.service';

export abstract class PxdGridViewEditService extends PxdGridEditService {

  constructor(
    resource: string,
    keys: Array<string>,
  ) {
    super(resource, keys);
  }

  public checkCellType(type: string) {

  }

  public geoEditable(test: any) {
    return test;
  }

  public valueChange(event, method, dataItem?) {
    return this[method](event, dataItem);
  }
}